import * as CSS from "csstype";
import { Table as BulmaTabel } from "react-bulma-components";
import styled from "styled-components";

import { RESPONSIVE } from "helpers/responsive";

// FIXME 削除
export const Wrapper = styled.div`
  &:not(:nth-child(2)) {
    border-top: 1px solid hsl(0, 0%, 86%);
    padding-top: 2rem;
  }
  margin-top: 2rem;
`;

export const Table = styled(BulmaTabel)`
  max-width: 100%;
  table-layout: fixed;

  tr {
    &:not(:nth-child(2)) {
      border-top: 1px solid hsl(0, 0%, 86%);
      padding-top: 4rem;
    }
    margin-top: 4rem;
  }
`;

export const Th = styled.th<CSS.Properties>`
  &&& {
    width: ${(p) => p.width || null};
    min-width: 4rem;
    background-color: hsl(219, 70%, 96%);
    border-width: 1px;
    padding: 0.3rem;
    vertical-align: middle;
  }

  @media ${RESPONSIVE.DESKTOP} {
    &&& {
      padding: 1rem;
    }
  }
`;

export const ThSmall = styled(Th)`
  width: 60px;

  @media ${RESPONSIVE.DESKTOP} {
    width: 120px;
  }
`;

export const ThMedium = styled(Th)`
  width: 80px;

  @media ${RESPONSIVE.DESKTOP} {
    width: 160px;
  }
`;

export const ThLarge = styled(Th)`
  width: 100px;

  @media ${RESPONSIVE.DESKTOP} {
    width: 200px;
  }
`;

export const ThUseCommuterPass = styled(Th)`
  width: 32px;
  min-width: unset !important;

  @media ${RESPONSIVE.DESKTOP} {
    width: 66px;
  }
`;

export const Td = styled.td<CSS.Properties>`
  &&& {
    width: ${(p) => p.width || null};
    min-width: 4rem;
    border-width: 1px;
    word-break: break-all;
    padding: 0.3rem;
    vertical-align: middle;
  }

  @media ${RESPONSIVE.DESKTOP} {
    &&& {
      padding: 1rem;
    }
  }
`;

export const TdUseCommuterPass = styled(Td)`
  min-width: unset !important;
`;

export const RouteTable = styled(Table)`
  border-bottom: 1px solid #dbdbdb;
  width: 100%;

  @media ${RESPONSIVE.DESKTOP} {
    width: 50%;
  }
`;

export const RouteTh = styled(Th)`
  width: 100px;

  @media ${RESPONSIVE.DESKTOP} {
    width: 180px;
  }
`;
